import Catalog from 'catalog/containers/Catalog'

export const RouteConfig = [
  {
    path: '/catalog/',
    component: Catalog,
  },
]
